import { useEffect } from "react";
import Hero from "@/components/home/Hero";
import SubscribeOn from "@/components/podcast/SubscribeOn";
import LatestEpisodes from "@/components/home/LatestEpisodes";
import YouTubeClips from "@/components/podcast/YouTubeClips";
import AboutManuel from "@/components/home/AboutManuel";
import SponsorCTA from "@/components/home/SponsorCTA";

// JSON-LD structured data for the homepage.
// Manuel Santana is referenced by canonical @id — no duplicate Person entity created here.
const HOMEPAGE_JSONLD = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "PodcastSeries",
      "@id": "https://proveyourpointpodcast.com/#podcast",
      "name": "Prove Your Point Podcast",
      "url": "https://proveyourpointpodcast.com/",
      "description":
        "Prove Your Point Podcast is a relationship, culture, and social commentary podcast hosted by Manuel Santana.",
      "author": { "@id": "https://iammanuelsantana.com/#person" },
      "creator": { "@id": "https://iammanuelsantana.com/#person" },
      "inLanguage": "en-US",
      "sameAs": [
        "https://www.imdb.com/title/tt43306414",
        "https://open.spotify.com/show/033rgTfiTjLGPaTefyE3OA",
        "https://podcasts.apple.com/us/podcast/prove-your-point-podcast/id1896911048",
        "https://music.youtube.com/playlist?list=OLSrHAmrIcS_Q57SjoVSd8DZvi1m9ymhB5A",
        "https://www.iheart.com/podcast/269-prove-your-point-podcast-336541374/",
        "https://music.amazon.com/podcasts/653067bc-2908-4491-9021-7e97017495d4/prove-your-point-podcast",
      ],
    },
    {
      "@type": "WebSite",
      "@id": "https://proveyourpointpodcast.com/#website",
      "url": "https://proveyourpointpodcast.com/",
      "name": "Prove Your Point Podcast",
      "about": { "@id": "https://proveyourpointpodcast.com/#podcast" },
    },
    {
      "@type": "WebPage",
      "@id": "https://proveyourpointpodcast.com/#webpage",
      "url": "https://proveyourpointpodcast.com/",
      "name": "Prove Your Point Podcast",
      "isPartOf": { "@id": "https://proveyourpointpodcast.com/#website" },
      "about": { "@id": "https://proveyourpointpodcast.com/#podcast" },
      "mainEntity": { "@id": "https://proveyourpointpodcast.com/#podcast" },
    },
  ],
};

export default function Home() {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-jsonld", "homepage");
    script.text = JSON.stringify(HOMEPAGE_JSONLD);
    document.head.appendChild(script);
    return () => {
      script.remove();
    };
  }, []);

  return (
    <div data-testid="home-page">
      <Hero />
      <SubscribeOn />
      <LatestEpisodes />
      <YouTubeClips limit={6} />
      <AboutManuel />
      <SponsorCTA />
    </div>
  );
}
